import { createContext, useContext, useState, useEffect } from 'react';
import { verifyAuth } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('chronos_token');
    if (token) {
      const timeout = setTimeout(() => {
        setLoading(false);
      }, 5000);

      verifyAuth()
        .then((res) => {
          setUser({ username: res.data.username, role: res.data.role });
        })
        .catch(() => {
          localStorage.removeItem('chronos_token');
          localStorage.removeItem('chronos_username');
          setUser(null);
        })
        .finally(() => {
          clearTimeout(timeout);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const loginUser = (token, username, role = 'user') => {
    localStorage.setItem('chronos_token', token);
    localStorage.setItem('chronos_username', username);
    setUser({ username, role });
  };

  const logout = () => {
    localStorage.removeItem('chronos_token');
    localStorage.removeItem('chronos_username');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
